/**
 * Helpers de token para la validación estilo `gondola-billing-engine`. Allí se usa
 * `ngx-cookie-service`; aquí se lee la cookie nativamente para no sumar una dependencia
 * (el repo mantiene un set de deps mínimo), con el mismo comportamiento.
 */

/** Lee una cookie del `document`; `''` si no existe. Equivale a `CookieService.get`. */
export function getCookie(name: string): string {
  const escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
  const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + escaped + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : '';
}

/** Borra una cookie (mismo `path` con el que se creó). */
export function deleteCookie(name: string, path = '/'): void {
  document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

/**
 * Decodifica el payload (claims) de un JWT en base64url. `null` si no es decodificable.
 * No verifica la firma: esa validación es del gateway, no del front.
 */
export function decodeJwtPayload<T = Record<string, unknown>>(jwt: string | null): T | null {
  if (!jwt) return null;
  try {
    const part = jwt.split('.')[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json) as T;
  } catch {
    return null;
  }
}
